import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { GlobalVariable } from "app/global/global";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class ArchivoService {
  //
  url: string = GlobalVariable.BASE_API_URL + "api/archivo/";
  baseUrl: string = GlobalVariable.BASE_API_URL + "storage";
  public supportedFileTypes = [
  "dcm", "DCM",        // Imágenes médicas (DICOM)
  "pdf", "PDF",        // Documentos
  "xlsx", "xls",       // Hojas de cálculo
  "jpg", "jpeg", "png", // Imágenes comunes
  "gif", "bmp", "webp", "tiff", "tif", "svg", "heic", "avif" // Imágenes adicionales
];

  //
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  //
  listar(id): Observable<any> {
    return this.http.get(this.url + "listar/" + id);
  }

  //
  primerArchivo(id): Observable<any> {
    return this.http.get(this.url + "listar/" + id);
  }

  //
  borrar(id): Observable<any> {
    return this.http.delete(this.url + "borrar/" + id);
  }

  getImagenProtegida(
    idPaciente: number,
    idEstudio: number,
    nombre: string
  ): Observable<Blob> {
    return this.http.get(
      `${GlobalVariable.BASE_API_URL}api/archivo/${idPaciente}/${idEstudio}/${nombre}`,
      {
        // headers,
        responseType: "blob",
      }
    );
  }

  blobToSafeUrl(blob: Blob): SafeUrl {
    const url = URL.createObjectURL(blob);
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  descargarArchivo(idPaciente: number, idEstudio: number, nombre: string) {
    const url = `${GlobalVariable.BASE_API_URL}api/archivo/descargar/${idPaciente}/${idEstudio}/${nombre}`;
    return this.http.get(url, {
      responseType: "blob",
      observe: "response",
    });
  }

  getLinkTemporal(
    idPaciente: number,
    idEstudio: number,
    nombre: string
  ): Observable<string> {
    const url = `${GlobalVariable.BASE_API_URL}api/archivo/link-temporal/${idPaciente}/${idEstudio}/${nombre}`;
    return this.http.get(url, { responseType: "text" }); 
  }
}
